<app-title-bar rootBreadCrumbs="['i18n.core.navigation.parking']" titleText="i18n.core.navigation.parking-card-admin"></app-title-bar>
<div class="row">
  <div class="col-12 mb-2">
    <div class="header-wrapper d-flex align-items-center">
      <app-client-autocomplete [(selectedClient)]="selectedClient" class="client-autocomplete me-2"></app-client-autocomplete>
    </div>
  </div>
</div>
@if (selectedClient) {
  <app-parking-card-grid [isAdmin]="true" #gridComponent></app-parking-card-grid>
}
